'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/categories", "/categories/list");

  $stateProvider
    .state('categories', {
      url: '/categories',
      template: require('./categories.html'),
      authenticate: true
    })
    .state('categories.list', {
      url: '/list?category',
      template: require('./list/list.html'),
      controller: 'CategoriesListController',
      controllerAs: 'cListCtrl'
    })
    .state('categories.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'CategoriesAddController',
      controllerAs: 'cAddCtrl'
    })
    .state('categories.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'CategoriesEditController',
      controllerAs: 'cEditCtrl'
    })
    .state('categories.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'CategoriesShowController',
      controllerAs: 'cShowCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/categories/categories.routes.js